const service = '/order';
const order = {
  orderCreate: service + '/psa/v1/order',
  orderStatus: service + '/psa/v1/order/status',
  orderUpdate: service + '/psa/v1/order/update',

}

export default order



// WEBPACK FOOTER //
// ./src/apis/services/order.js